import axios from 'axios';
import { API_ROUTES } from '@/config/api-routes';
export async function fetchChatMessages(roomId, page = 0, size = 50) {
    const { data } = await axios.get(API_ROUTES.chat.roomMessages(roomId), { params: { page, size, sort: 'createdAt,asc' } });
    if (Array.isArray(data)) {
        return data;
    }
    return data.content ?? [];
}
export async function sendChatMessage(roomId, content) {
    const { data } = await axios.post(API_ROUTES.chat.roomMessages(roomId), {
        content,
    });
    return data;
}
export async function updateChatMessage(roomId, messageId, payload) {
    const { data } = await axios.put(API_ROUTES.chat.roomMessage(roomId, messageId), {
        contentType: 'text',
        parentMessageId: 0,
        ...payload,
    });
    return data;
}
export async function deleteChatMessage(roomId, messageId) {
    await axios.delete(API_ROUTES.chat.roomMessage(roomId, messageId));
}
export async function markChatRoomRead(roomId, lastReadMessageId) {
    await axios.patch(API_ROUTES.chat.roomRead(roomId), { lastReadMessageId });
}
export async function deleteChatRoom(roomId) {
    await axios.delete(API_ROUTES.chat.room(roomId));
}
export async function fetchChatRoomMembers(roomId) {
    const { data } = await axios.get(API_ROUTES.chat.roomMembers(roomId), { params: { 'leftAt.specified': false } });
    if (Array.isArray(data))
        return data;
    return data.content ?? [];
}
export async function upsertChatRoomMember(roomId, userId, payload) {
    const { data } = await axios.put(API_ROUTES.chat.roomMember(roomId, userId), payload);
    return data;
}
export async function removeChatRoomMember(roomId, userId) {
    await axios.delete(API_ROUTES.chat.roomMember(roomId, userId));
}
export async function fetchChatRoom(roomId) {
    const { data } = await axios.get(API_ROUTES.chat.room(roomId));
    return data;
}
